import clsx from 'clsx';
import type { UseFormRegisterReturn } from 'react-hook-form';
import type { VacationModality } from '../../../models/vacation.types';
import {
    MODALITY_OPTIONS,
    SELL_SINGLE_PERIOD_OPTION,
    buildPartialBalanceHint,
    buildPartialBalanceOption,
} from '../vacationRequestForm.definitions';

export interface ModalityFieldsetProps {
    value: VacationModality | '';
    disabled?: boolean;
    sellDaysRequested?: boolean;
    partialBalanceDays?: number;
    registerProps: UseFormRegisterReturn<'modality'>;
}

export function ModalityFieldset({
    value,
    disabled,
    sellDaysRequested,
    partialBalanceDays,
    registerProps,
}: ModalityFieldsetProps) {
    const options =
        partialBalanceDays !== undefined
            ? [buildPartialBalanceOption(partialBalanceDays)]
            : MODALITY_OPTIONS.map((option) =>
                  sellDaysRequested && option.value === '30' ? SELL_SINGLE_PERIOD_OPTION : option
              );

    return (
        <fieldset>
            <legend className="text-sm font-medium text-raro-gray-700 font-montserrat">
                Modalidade de férias
            </legend>
            <div className="mt-2 space-y-2">
                {options.map((option) => (
                    <label
                        key={option.value}
                        className={clsx(
                            'flex cursor-pointer items-center gap-3 rounded-xl border p-3 transition-colors',
                            value === option.value
                                ? 'border-primary-500 bg-primary-50'
                                : 'border-primary-200 hover:bg-primary-50'
                        )}
                    >
                        <input
                            type="radio"
                            value={option.value}
                            disabled={disabled}
                            {...registerProps}
                            className="h-4 w-4 text-primary-600 focus:ring-primary-500"
                        />
                        <span>
                            <span className="block text-sm font-medium text-raro-gray-900 font-montserrat">
                                {option.label}
                            </span>
                            <span className="block text-xs text-raro-gray-500 font-montserrat">
                                {option.description}
                            </span>
                        </span>
                    </label>
                ))}
            </div>
            {partialBalanceDays !== undefined && (
                <p className="mt-2 text-xs text-raro-gray-500 font-montserrat">
                    {buildPartialBalanceHint(partialBalanceDays)}
                </p>
            )}
        </fieldset>
    );
}

export default ModalityFieldset;
